import { Icon } from "@iconify/react/dist/iconify.js";
import Text from "./Text";
import { twMerge } from "tailwind-merge";

const Collapse = ({
  title,
  content,
  index,
  image,
  video,
  colored,
  backgroundColor,
  autoCollapsed,
  lang,
  children,
  withoutBorder,
  className,
}) => {
  let displayedIndex = "";
  if (index) {
    displayedIndex = index < 10 ? `0${index}` : `${index}`;
  }
  let isAr = lang=="ar"
  return (
    <label
      className={twMerge(
        `relative collapse ${
          colored ? "border-[0.5px] border-[rgb(234,234,234)] " : ""
        } bg-white rounded-2xl min-h-[4.5rem]`,
        className
      )}
    >
      <input type="checkbox" className="peer" defaultChecked={autoCollapsed} />
      <div className={`bg-white border-2 border-orange text-orange peer-checked:text-white peer-checked:bg-orange peer-checked:rotate-180 rounded-[6px] absolute z-10 cursor-pointer ${isAr ?"left-5":"right-5"} top-5 md:top-5 w-6 h-6 md:w-8 md:h-8 flex items-center justify-center`}>
        <Icon
          icon={"ep:arrow-down-bold"}
          className="transition-all text-infoText"
        />
      </div>
      <div
        className={`collapse-title min-h-[4.5rem] gap-3 ${
          colored ? `${cardBackground}` : ""
        } ${
          colored
            ? "peer-checked:rounded-b-cardBorder "
            : `${
                withoutBorder
                  ? ""
                  : "border-b-[1px] border-transparent peer-checked:border-lightGray dark:peer-checked:border-transparent"
              } mx-0 md:mx-5 w-auto `
        } `}
      >
        <div className="flex items-start ">
          <Text titleColors text={displayedIndex} sectionTitle />
          <Text
            titleColors
            text={title}
            bold
            className="text-infoText md:text-subtitle px-2 mt-1"
          />
        </div>
      </div>
      <div
        className={`collapse-content mNormal md:text-normal`}
      >
         {children ? children : null}
       
      </div>
    </label>
  );
};

export default Collapse;
